module.exports = __webpack_public_path__ + "static/media/grace.f92c0bb7.jpeg";